module.exports = __webpack_public_path__ + "img/74.ed275054.svg";